import { config } from '../../../config/runtimeConfig';

/**
 * Static asset paths for brand logos used on the new-model landing.
 * Centralized to avoid magic-string asset paths sprinkled across components.
 */
export const BRAND_LOGO_PATHS = Object.freeze({
  OMODA: '/assets/brands/omoda.svg',
  JAECOO: '/assets/brands/jaecoo.png',
});

/**
 * Returns src/alt for the logo pill on top of the hero.
 *
 * - For used-VIN cars: dealer logo (DEALER_LOGO_URL from runtime config).
 * - For new-model cars (Autodis OMODA/JAECOO, issue #884): the brand logo
 *   of the car itself — JAECOO for JAECOO models, OMODA otherwise.
 *
 * Pure helper — moved out of inline IIFE for readability and to avoid
 * recreating the function on every render.
 *
 * @param {object} car — Car object (DealerCarDto). Pass `null` to fall back
 *   to the dealer logo.
 * @returns {{ src: string, alt: string }}
 */
export const getBrandLogo = (car) => {
  if (!car?.isNewModel) {
    return { src: config.DEALER_LOGO_URL, alt: 'Dealer logo' };
  }
  const brand = (car.make || '').toUpperCase();
  if (brand.startsWith('JAECOO')) {
    return { src: BRAND_LOGO_PATHS.JAECOO, alt: 'JAECOO' };
  }
  return { src: BRAND_LOGO_PATHS.OMODA, alt: 'OMODA' };
};
